import API, { responseOf } from "./base";
import type { PreferenceContainer } from "../model/Preference";

export const get = (userId: string): Promise<PreferenceContainer> =>
  responseOf(API.get(`/preferences/${userId}`));

export const set = async (
  userId: string,
  preferences: PreferenceContainer,
): Promise<void> => {
  await API.put(`/preferences/${userId}`, preferences);
};
